import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCards } from "../../app/cards/cards.slice";
import { fetchAllDecks } from "../../app/catalog/catalog.slice";
import Carrousel from "./components/Carrousel";
import StoryCard from "./components/StoryCard";
import StoryWord from "./components/StoryWord";
import NewDeck from "./components/NewDeck";
import NewText from "./components/NewText";
import { Box, Paper, Tabs, Tab, Typography } from "@mui/material";

const tabs = ["Carrousel", "Story card", "Story Word", "New deck", "New text"];

const SocialHub = () => {
  const dispatch = useDispatch();
  const catalog = useSelector((state) => state.catalog);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCardProp, setSelectedCardProp] = useState("");
  const [selectedDeckProp, setSelectedDeckProp] = useState("");

  useEffect(() => {
    dispatch(fetchCards({ take: 100, skip: 0 }));
  }, []);

  // Usar los decks cargados al iniciar la app (catalog.allDecks)
  useEffect(() => {
    if (!catalog?.allDecks?.length && !catalog?.isLoadingDecks) {
      dispatch(fetchAllDecks());
    }
  }, [dispatch, catalog?.allDecks?.length, catalog?.isLoadingDecks]);

  const commonProps = { selectedCardProp, setSelectedCardProp, selectedDeckProp, setSelectedDeckProp };

  return (
    <Box>
      <Paper sx={{ borderRadius: 3, overflow: "hidden", mb: 3 }}>
        <Box sx={{ px: 3, pt: 3 }}>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>Social Hub</Typography>
          <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
            {tabs.map((label, i) => (
              <Tab key={i} label={label} sx={{ textTransform: "none", fontWeight: 600 }} />
            ))}
          </Tabs>
        </Box>
      </Paper>

      <Box>
        {activeTab === 0 && <Carrousel {...commonProps} />}
        {activeTab === 1 && <StoryCard {...commonProps} />}
        {activeTab === 2 && <StoryWord {...commonProps} />}
        {activeTab === 3 && <NewDeck {...commonProps} />}
        {activeTab === 4 && <NewText {...commonProps} />}
      </Box>
    </Box>
  );
};

export default SocialHub;
